import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnumMicroServices } from '../../enumerations/enum-micro-services';

import { GetClosingTenderRequestModel } from '../../models/tender-filter.model';

import { HttpUtilsService } from '../common/http-utils.service';
import { UserUtilService } from '../common/user-util.service';
import { formatDate } from '@angular/common';

import { LoginRequestModel } from '../../models/loginRequestModel';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthService {


  closetender(getClosingTenderRequestModel: GetClosingTenderRequestModel) {
    throw new Error('Method not implemented.');
  }
  version: string = "1.0.0";
  service: string = "publicportal";
  microServiceName: string = EnumMicroServices.WebPortal;
  officeId = 1233;
  secretKeyResponse: any;
  public userInfo: UserModel | null = null;
  private loggedIn = new BehaviorSubject<boolean>(this.hasUser());
  public isLoggedIn$ = this.loggedIn.asObservable();

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService,private userUtilService:UserUtilService) {
    this.officeId = this.userUtilService?.selectedEnvironment?.officeId;
  }
  private hasUser(): boolean {
    return !!localStorage.getItem('userInfo');
  }

  login(r: LoginRequestModel): Observable<any> {
    this.secretKeyResponse= this.userUtilService.getSecretKeyInformation();
    var url = environment.getAPIPath(this.microServiceName, this.service, "userloginformdashboard", this.service, this.version);
    var date = new Date()
    var header = "user=" + r.userName + "| time=" + date.toTimeString()
    header = btoa(header);
    sessionStorage.setItem("head", header);
    localStorage.setItem("head", header);
    // localStorage.setItem("userName", r.userName);
    var TID = formatDate(date, 'yyyyMMdd.HHmmss.SSS', 'en-US', '+0530');
    TID = btoa(TID);
    // header = Buffer.from(header).toString('base64')
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',
      'Aaa-Log' : header,
      'SID': header,
      'TID': TID
    });
    var req = JSON.stringify(r);
    return this.http.post(url, req,
      { headers: headers }).pipe(
      map((res: any) => res));

  }

  changePassword(r: any): Observable<any> {
    this.secretKeyResponse= this.userUtilService.getSecretKeyInformation();
    var url = environment.getAPIPath(this.microServiceName, this.service, "userpasswordupdate", this.service, this.version);
    var date = new Date()

    // localStorage.setItem("userName", r.userName);
    var TID = formatDate(date, 'yyyyMMdd.HHmmss.SSS', 'en-US', '+0530');
    TID = btoa(TID);

    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Authorization': 'Basic YWRtaW46cHByYTEy',
      'TID': TID
    });
    var req = JSON.stringify(r);
    return this.http.post(url, req,
      { headers: headers }).pipe(
      map((res: any) => res));

  }





  setUserInfo(user: UserModel) {
    this.userInfo = user;
    localStorage.setItem('userInfo', JSON.stringify(user));
    this.loggedIn.next(true);  }

  getUserInfo(): UserModel | null {
    return this.userInfo || this.loadUserInfo();
  }


  private loadUserInfo(): UserModel | null {
    const storedUser = localStorage.getItem('userInfo');
    if (storedUser) {
      this.userInfo = JSON.parse(storedUser);
      return this.userInfo;
    }
    return null;
  }

  clearUserInfo() {
    this.userInfo = null;
    localStorage.removeItem('userInfo');
    sessionStorage.removeItem('reloaded');

  }

}

export interface UserModel {
  ID: number;
  FirstName: string;
  LastName: string;
  Username: string;
  category_id: string;
  OrganizationName: string;
}
